import React, { FC } from 'react';
import * as Contentful from 'contentful';
import {
  TypeAddToCartCtaFields,
  TypeLink_externalFields,
  TypeLink_internalFields,
} from '@/core/generated-types';
import { UniversalLink } from '@/components/common';
import classNames from 'classnames';
import { getCTAStyles } from '@/components/utils';
import { CTA_COLORS } from '../types';

type ButtonStyle = 'Link' | 'Primary' | 'Secondary' | 'Holiday';

interface UniversalCtaProps {
  className?: string;
  defaultButtonStyle?: ButtonStyle;
  link: Contentful.Entry<
    TypeLink_internalFields | TypeLink_externalFields | TypeAddToCartCtaFields
  >;
  queryString?: string;
  onClick?: React.MouseEventHandler<any> | undefined;
}

function getClassNames(buttonStyle?: ButtonStyle, variantCTAStyles?: string) {
  switch (buttonStyle) {
    case 'Link':
      return 'font-bold text-blue-deep underline';
    case 'Primary':
      return `btn btn-primary btn-responsive ${variantCTAStyles}`;
    case 'Secondary':
      return 'btn btn-responsive btn-secondary';
    case 'Holiday':
      return `btn btn-holiday btn-responsive`;
  }
}

const UniversalCta: FC<UniversalCtaProps> = ({
  link,
  defaultButtonStyle = 'Primary',
  className,
  queryString,
  onClick,
}) => {
  const ctaColor = CTA_COLORS.DEFAULT;
  const variantCTAStyles = getCTAStyles(ctaColor);
  if (!link?.sys || !ctaColor) return null;

  const ctaClassName = getClassNames(
    link.fields?.buttonStyle || defaultButtonStyle,
    variantCTAStyles,
  );

  return (
    <UniversalLink
      link={link}
      classes={classNames(className, ctaClassName)}
      queryString={queryString}
      onClick={onClick}
    />
  );
};

export default React.memo(UniversalCta);
